import React, { useState, useEffect } from "react";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
function StartMinting() {
  const [mintAmount, setMintAmount] = useState(1);
  const decrementMintAmount = () => {
    let newMintAmount = mintAmount - 1;
    if (newMintAmount < 1) {
      newMintAmount = 1;
    }
    setMintAmount(newMintAmount);
  };

  const incrementMintAmount = () => {
    let newMintAmount = mintAmount + 1;
    if (newMintAmount > 10) {
      newMintAmount = 10;
    }
    setMintAmount(newMintAmount);
  };
  return (
    <div className="bg-[#121127] p-5 mt-[350px] 2xl:mt-[350px] md:mr-32 m-12 mb-64 rounded-md 2xl:h-[500px] 2xl:w-[540px] h-[500px] text-center lg:h-[500px] lg:w-[540px]  z-10 flex flex-col justify-between">
      <div className="md:text-center text-left">
        {" "}
        <h1 className="text-transparent mt-5 bg-clip-text md:px-10 font-bold pb-5 bg-gradient-to-r from-[#8926B6] to-[#EABCFF] sm:text-4xl text-2xl  md:leading-9 lg:text-left text-center sm:text-[26px] md:text-[40px] lg:text-[48px] ">
          Start Minting
        </h1>
      </div>{" "}
      <div>
        <button className="rounded bg-[#395e96] text-white sm:text-[20px] mb-5  text-md font-extrabold sm:py-2 p-1 px-4 sm:px-2 w-8/12 lg:w-7/12 md:w-full sm:w-5/12 hover:scale-105 ">
          Connect Wallet
        </button>
      </div>
    </div>
  );
}

export default StartMinting;
